<template>
    <div class="map-layer-settings">
        <el-dialog :visible.sync="dialogVisible" :show-close="false" :append-to-body="true" top="0" :modal="mobile" custom-class="map-layer-settings__dialog">
            <div class="map-layer-settings__content">
                <div class="map-layer-settings__head">
                    <span class="caption-light">Ebeneneinstellungen</span>
                    <div class="map-layer-settings__close" @click="closeClickHandler">
                        <icon><IconClose/></icon>
                    </div>
                </div>
                <div class="map-layer-settings__list">
                    <div class="map-layer-settings__item" v-for="style in mapStyles" :key="style.id" :class="{'is-style-selected': activeMapStyle === style.id}" @click="mapStyleClickHandler(style.id, style.trackingLabel)">
                        <img class="map-layer-settings__item__image" :src="style.thumb" />
                        <span class="map-layer-settings__item__label">{{style.label}}</span>
                        <span class="map-layer-settings__item__radio"></span>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setPermanentData } from '@/utils/browser-storage';

import Icon from '@/components/Icon.vue'
import IconClose from '@/components/icons/IconClose.vue'

import { trackEvent, trackGa4Event } from '@/utils/tracking'

export default {
    components: {
        Icon,
        IconClose
    },
    data() {
        return {
            dialogVisible: false,
            mapStyles: [
                {
                    id: 'day',
                    label: 'Klassisch',
                    trackingLabel: 'Standard',
                    thumb: `${process.env.BASE_URL}/images/map-styles/map-style-day.png`,
                },
                {
                    id: 'contrast',
                    label: 'Hoher Kontrast',
                    trackingLabel: 'High Contrast',
                    thumb: `${process.env.BASE_URL}/images/map-styles/map-style-contrast.png`,
                },
                {
                    id: 'night',
                    label: 'Nacht',
                    trackingLabel: 'Dark',
                    thumb: `${process.env.BASE_URL}/images/map-styles/map-style-night.png`,
                },
            ]
        }
    },
    computed: {
        ...mapGetters(['mobile', 'activeMapStyle']),
    },
    methods: {
        closeClickHandler() {
            this.closeDialog();
        },
        // dialogCloseHandler(){
        // },
        mapStyleClickHandler(mapStyleId, trackingLabel) {
            this.setStyle(mapStyleId);
            trackEvent({ category: 'Route Planner', action: 'Map Type', label: trackingLabel })
            
            const ga4TrackingLabel = trackingLabel.replace(/ /g, "_").toLowerCase();
            trackGa4Event({ga4Parameter1Name: 'map_type', ga4Parameter1Value: ga4TrackingLabel, ga4Event: 'layers'})
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        showDialog() {
            this.dialogVisible = true;
        },
        setStyle(mapStyleId) {
            this.$store.commit('setActiveMapStyle', mapStyleId);
            setPermanentData('map-style', {'style': mapStyleId});
            this.closeDialog();
        }
    }
}
</script>

<style lang="scss">
.map-layer-settings {
    $block: &;
    &__dialog{
        max-width: 350px;
        margin: 0;
        bottom: 30px;
        right: 84px;
        position: absolute;

        @include mq($until: tablet) {
            margin: 20px auto;
            border-radius: 9px;
            width: calc(100% - 32px);
            position: relative;
            bottom: auto;
            right: auto;
            top: 50%;
            transform: translateY(-50%);
        }
        
        .el-dialog{
            &__header {
                display: none;
            }
            &__body {
                padding: 0;
                word-break: initial;
                font-size: 15px;
            }
        }
    }

    &__content {
        padding: 8px 16px;
        color: $color-black;
    }

    &__head {
        position: relative;
        margin-bottom: 8px;
    }
    &__close {
        position: absolute;
        top: 0;
        right: 0;
        color: $color-black-02;
        transition: 0.2s;
        cursor: pointer;

        .no-touch &:hover {
            color: $color-black-04;
        }
        @include mq(tablet) {
            display: none;
        }
    }

    &__item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-top: 1px solid $color-black-005;
        cursor: pointer;
        &:last-child {
            padding-bottom: 0;
        }
        .no-touch &:hover {
            #{$block} {
                &__item {
                    &__radio {
                        border-color: $color-black;
                    }
                }
            }
        }
        &.is-style-selected {
            pointer-events: none;
        }
        &__image {
            width: 40px;
            height: 40px;
            border-radius: 5px;
            margin-right: 16px;
            flex-shrink: 0;
        }
        &__label {
            flex-grow: 1;
        }
        &__radio {
            transition: border 0.2s;
            flex-shrink: 0;
            width: 17px;
            height: 17px;
            position: relative;
            border-radius: 20px;
            border: 2px solid $color-grey;
            margin-right: 3px;
            .is-style-selected & {
                border-width: 5px;
                border-color: $color-blue;
            }
        }
    }
}


@include mq(tablet) {
    .dialog-fade-enter-active, .dialog-fade-leave-active {
        .map-layer-settings__dialog {
            transition: transform .3s, opacity 0.3s;
            opacity: 1;
        }
    }
    .dialog-fade-enter, .dialog-fade-leave-to {
        .map-layer-settings__dialog {
            transform: translateY(30px);
            opacity: 0;
        }
    }
}
</style>